module.exports = __webpack_public_path__ + "img/game3.2cdeb12b.png";